import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { orpc } from "@/client";
import { errorCode } from "@/lib/error-code";
import { DocumentosLabels } from "@/lib/labels/documentos";
import { TermosLabels } from "@/lib/labels/termos";

function useInvalidate() {
	const queryClient = useQueryClient();

	return () => {
		void queryClient.invalidateQueries({ queryKey: orpc.signatures.key() });
	};
}

function onError(error: any) {
	const code = errorCode(error);

	if (code === "PAGE_OVERFLOW") {
		toast.error(TermosLabels.pageOverflow(error.data.page));

		return;
	}

	toast.error(DocumentosLabels.error(code));
}

export function useSignatureList(personId: number) {
	return useQuery(orpc.signatures.listFor.queryOptions({ input: { personId } }));
}

export function useSignatureSend() {
	const invalidate = useInvalidate();

	return useMutation(
		orpc.signatures.send.mutationOptions({
			onSuccess: () => {
				invalidate();
				toast.success(DocumentosLabels.sentToast);
			},
			onError,
		}),
	);
}

export function useSignatureResend() {
	return useMutation(
		orpc.signatures.resend.mutationOptions({
			onSuccess: () => toast.success(DocumentosLabels.resentToast),
			onError,
		}),
	);
}

export function useSignatureCancel() {
	const invalidate = useInvalidate();

	return useMutation(
		orpc.signatures.cancel.mutationOptions({
			onSuccess: () => {
				invalidate();
				toast.success(DocumentosLabels.canceledToast);
			},
			onError,
		}),
	);
}
